<template>
  <div class="linked-companies">
    <LoadingSpinner v-if="loading" />

    <template v-else>
      <LinkedCompaniesGroup
        v-if="sameGroup.length > 0"
        title="Même groupe ou réseau"
        hint="Structures rattachées à la même entité juridique ou à la même enseigne."
        :companies="sameGroup"
      />
      <DetailEmpty v-else tag="p">
        Aucune société du même groupe. Le rapprochement se fait sur l'entité juridique (SIRET)
        et l'enseigne. Une fiche sans SIRET renseigné n'en a aucune.
      </DetailEmpty>

      <LinkedCompaniesAiSearch
        v-if="canSearchAi"
        :companies="aiCompanies"
        :loading="aiLoading"
        :searched="aiSearched"
        :error="aiError"
        @search="$emit('search-ai')"
      />
    </template>
  </div>
</template>

<script setup>
/**
 * Deux blocs : le même groupe, trouvé d'office et sûr ; les références du
 * même métier, cherchées par l'IA sur un bouton (retour Figma du 2026-09-11 :
 * le « même secteur » par code NAF proposait des sociétés sans rapport).
 */
import { LoadingSpinner } from '../ui'
import DetailEmpty from '../data/DetailEmpty.vue'
import LinkedCompaniesGroup from './LinkedCompaniesGroup.vue'
import LinkedCompaniesAiSearch from './LinkedCompaniesAiSearch.vue'

defineProps({
  sameGroup: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  /** Une fiche professionnelle avec un SIRET : sinon rien à comparer. */
  canSearchAi: { type: Boolean, default: false },
  aiCompanies: { type: Array, default: () => [] },
  aiLoading: { type: Boolean, default: false },
  aiSearched: { type: Boolean, default: false },
  aiError: { type: String, default: null }
})

defineEmits(['search-ai'])
</script>

<style scoped>
.linked-companies {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
}
</style>
